<template>
  <!-- 导出历史费率 -->
  <div>
    <Modal v-model="visible" title="导出历史费率" width="550px" :footer-hide="true" :mask-closable="false" class="my-modal">
      <Form ref="form" :model="formData" class="page-form" :label-width="80" v-if="visible">
        <FormItem label="生效时间" prop="date" class="full" :rules="$units.formRule.arrRequired('请选择生效时间')">
          <DatePicker
            :options="disableTime"
            type="daterange"
            format="yyyy-MM-dd"
            separator="至"
            :value="formData.date"
            placeholder="请选择"
            :start-date="startDate"
            @on-change="formData.date = $event"
            transfer
          ></DatePicker>
          <p class="info-text">请按照时间段导出对应服务费率的情况，单次最多支持一个月的数据导出。</p>
          <!-- <p class="info-text">当前仅支持个险历史费率导出。</p> -->
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submit" :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
  components: {},
  props: {},
  data() {
    const startDate = new Date(dayjs().subtract(1, 'month').format('YYYY-MM-DD'));
    return {
      visible: false,
      loading: false,
      formData: {},
      startDate: startDate,
      disableTime: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        }
      }
    };
  },
  mounted() {},
  methods: {
    open(data) {
      data = JSON.parse(JSON.stringify(data));
      data.date = [];
      this.formData = data;
      this.visible = true;
    },
    // 验证时间
    dateCheck(formData) {
      const snapStartTime = formData.date[0];
      const snapEndTime = formData.date[1];
      if (dayjs(snapEndTime).subtract(1, 'month').format('YYYY-MM-DD') > snapStartTime) {
        this.$notice.msg('生效时间最长选择一个月');
        return false;
      } else {
        formData.snapStartTime = snapStartTime+' 00:00:00';
        formData.snapEndTime = snapEndTime+' 23:59:59';
        return true;
      }
    },
    // 提交
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const formData = JSON.parse(JSON.stringify(this.formData));
          const apiPermissionCode = formData.apiPermissionCode;
          if(this.dateCheck(formData)) {
            delete formData.date;
            delete formData.apiPermissionCode;
            this.$units.downloadFile('/buz/commission/config/exportSnapShot', formData, 'POST', '', apiPermissionCode);
            this.visible = false;
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.ivu-date-picker {
  margin-bottom: 5px;
}
.info-text {
  font-size: 12px;
  line-height: 1.5;
  color: #666;
}
</style>